import Vue from "vue";

Vue.directive("outer-click", {
	bind: (el, binding) => {
        if (typeof binding.value === "function") {
			const bubble = binding.modifiers.bubble;
			const handler = e => {
				if (bubble || (!el.contains(e.target) && el !== e.target))
					binding.value(e);
			}
			el.__vueClickOutside__ = handler;
			document.addEventListener("click", handler);
        }
	},
	unbind: el => {
        document.removeEventListener("click", el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
	}
});